<app-header></app-header>
<!-- mx-4 -->
<div *ngIf="companyDetails" class="enroll_form approval-section">
  <div class="reason_for_reject container">
    <a *ngIf="accountDetails.cnss != 0" class="pdf-container" href="{{cnss_url}}" target="_blank">
      <div class="pdf_icon"><img src="assets/images/cnsspdf.png"></div>
    </a>
    <div *ngIf="accountDetails.cnss == '3'" class="rejectedNote">
      <div class="id-status">
        <img class="img-fluid" src="/assets/images/reject.png">
        <h5 class="m-0 align-self-center">{{'Rejected' | translate}}</h5>
      </div>
      <div class="d-flex">
        <h5>{{'Status2'| translate}}&nbsp;:&nbsp;
        </h5>
        <h6> {{rejectReason.action}}</h6>
      </div>
      <!-- <h5 *ngIf="rejectReason.rejected_by">{{'Rejected by'| translate}} : {{rejectReason.rejected_by}}</h5> -->
      <h5>{{'Rejected on'| translate}} : {{rejectReason.rejected_on}}</h5>
      <h5 class="m-0">{{'Comments'| translate}} : {{rejectReason.rejected_comment}}</h5>
    </div>
    <div class="addButton" *ngIf=" accountDetails.cnamgs != 1 && accountDetails.cnamgs !=2">
      <div class="text-container">
        <div class="custom-container modify-btn">
          <p class="mb-2">{{'Please review and update the necessary information before submitting for approval. To make these changes'| translate}}</p>
          <button class="btn-medium" (click)="goToLinkBusiness()"><i class="fa-regular fa-pen-to-square"></i>{{'Modify' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="companyDetails" class="card_bg">
    <div class="head-title position-relative">
      <div class="">
        <a (click)="goback()"><i class="fa fa-angle-left"></i></a>
      </div>
      <div class="sec1">
        <h4>{{'EMPLOYER AFFILIATION REQUEST'|translate}}</h4>
        <h6>{{'(RÉGIME GÉNÉRAL/ADMINISTRATIONS/COLLECTIVITÉS LOCALES)'|translate}}</h6>
      </div>
      <div class="sec2">
        <img src="/assets/images/logoWithText.png" class="img-fluid">
        <div>CAISSE NATIONALE <br>DE SECURITE SOCIALE</div>
      </div>
    </div>
    <div class="line"></div>
    <form [formGroup]="cnssForm" (ngSubmit)="onSubmitCnssForm()">
      <div class="input_section">
        <h6 class="text-center mt-3">{{"Informations concernant l'identité de l'Employeur Personne Morale"|translate}} <br>
          {{'(Régime Général/Administrations/Collectivités locales)'|translate}}</h6>
        <div class="container mt-62">
          <div class="row mt-3">
            <div class="col-md-12">
              <label for="">{{'Company Name'|translate}}:</label>
              <h5 class="input-txt">{{companyDetails.name}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="">{{'Nom Commercial'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.trade_name}}</h5>
            </div>
            <div class="col-md-6">
              <label for="">{{'Administrative Name'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.administration_name}}</h5>
            </div>
            <div class="col-md-6">
              <label for="">{{'Acronym'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.acrononym}}</h5>
            </div>
          </div>
        </div>
        <div class="container mt-5">
          <h6 class="">{{"Informations liées à la localisation de l'employeur"|translate}}</h6>
        </div>
        <div class="line"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-6 mt-3">
              <label for="">{{'Region'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_region_name}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'City'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_city_name}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'District'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_district_name}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Neighbourhood'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_neighbourhood_name}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Street'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_street_name}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'N° Porte'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_door_no}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'place called'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_place}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Localité'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_locality}}</h5>
            </div>
          </div>
        </div>
        <div class="container mt-5">
          <h6 class="">{{"Informations liées au contact de l'employeur"|translate}}</h6>
        </div>
        <div class="line"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-6 mt-3">
              <label for="">{{'Contact 1' | translate}}</label>
              <!-- <input type="text" value="" formControlName="contact_1"> -->
              <h5 class="input-txt">{{companyDetails.telephone}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">BP</label>
              <h5 class="input-txt">{{companyDetails.business_post_box}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Contact 2' | translate}}</label>
              <h5 class="input-txt">{{companyDetails.mobile}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">Fax</label>
              <h5 class="input-txt">{{companyDetails.fax}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">E-mail</label>
              <h5 class="input-txt">{{companyDetails.email}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Website'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.website}}</h5>
            </div>
          </div>
        </div>
        <div class="container mt-5">
          <h6 class="">{{"Informations administratives de l'employeur"| translate}}</h6>
        </div>
        <div class="line"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-6 mt-3">
              <label for="">{{'Legal status'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.legal_status}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Employer Plan'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.employer_plan}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Taxpayer Number'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.tax}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Trade register number (RCCM)'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.rccm}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">NIF</label>
              <!-- <input type="text" value="" formControlName="nif"> -->
              <h5 class="input-txt">{{companyDetails.nif}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'SEEG subscription number'|translate}}</label>
              <!-- <input type="text" value="" formControlName="seeg_subscription_no"> -->
              <h5 class="input-txt">{{companyDetails.seeg_subscription_no}}</h5>
            </div>
            <!--       <div class="col-md-6 mt-3">
              <label for="">{{'Administration name'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.name}}</h5>
            </div> -->
            <div class="col-md-6 mt-3">
              <label for="">{{'Local community'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.local_community}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Department'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.department}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Municipality'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.municipality}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Township'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.township}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Takeover date'|translate}}</label>
              <h5 class="input-txt">{{takeover_date}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Former business manager'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.business_manager}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Maiden name'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.maiden_name}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Position'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.position}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Last name2'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.last_name}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'First name2'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.first_name}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Date of Birth' | translate}}</label>
              <h5 class="input-txt">{{date_of_birth}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Birthplace'| translate}}</label>
              <h5 class="input-txt">{{companyDetails.birth_place}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Country'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_country_id}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Nationality'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_nationality_id}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Manager'|translate}}</label>
              <div class="radio-container">
                <input type="radio" formControlName="manager" disabled [value]="1"> <span>{{'Yes'|translate}}</span>
                <input type="radio" formControlName="manager" disabled [value]="0"> <span>{{'No'|translate}}</span>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <label for="">{{'Activity'|translate}}</label>
              <textarea rows="6" cols="200" readonly class="input-txt">{{companyDetails.activity}}</textarea>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Employer fund'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.employer_fund}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Employer ID2'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.employer_code}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'ID proof'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.id_proof}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'ID proof number'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.id_number}}</h5>
            </div>
            <div class="col-md-12 mt-3">
              <label for="">{{'Address'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.address}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Phone number'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.phone_no}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Personal email'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_email}}</h5>
            </div>
            <div class="col-md-6 mt-3">
              <label for="">{{'Insurrance Number'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.insurrance_no}}</h5>
            </div>
            <!--   <div class="col-md-6 mt-3">
              <label for="">{{'Current Date'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.owner_country_id}}</h5>
            </div> -->
            <div class="col-md-6 mt-4" *ngIf="companyDetails.fc">
              <!-- <label for="fc_certificate" class="labeltxt">{{'Incorporation certificate (FC)' | translate}}</label> -->
              <a id="fc_certificate_name" [attr.href]="companyDetails.fc ? companyDetails.fc : null" class="viewFile text-center" target="_blank">
                <label for="fc_certificate" class="file-upload-card labeltxt ">
                  <div class="custom-container">
                    <!-- <img src="assets/images/upload_icon.png"> -->
                    <!-- <p class="text-center">{{'Upload image or drop a file' | translate}}</p> -->
                    <i class="fa fa-download" aria-hidden="true"></i>
                    <label for="fc_certificate" class="labeltxt readfor m-0">{{'Incorporation certificate (FC)' | translate}}</label>
                  </div>
                </label>
              </a>
              <!--  <input class="d-none" id="fc_certificate" type="file" name="fc_certificate" (change)="upload('fc_certificate', 'fc_certificate_name', $event, 'business_fc_certificate')" data-target="business_fc_certificate">
                  
                    <div *ngIf="isSubmitted && g.business_fc_certificate.errors" class="invalid-feedback">
                      <div *ngIf="g.business_fc_certificate.errors?.required">{{'Upload Incorporation certificate (FC)'|translate}} {{'is required'|translate}}</div>
                    </div> -->
            </div>

            <div class="col-md-6 mt-4" *ngIf="companyDetails.kbis_certificate">
              <a id="kbis_certificate_name" [attr.href]="companyDetails.kbis_certificate ? companyDetails.kbis_certificate : null" class="viewFile text-center" target="_blank">
                <label for="kbis_certificate" class="file-upload-card labeltxt ">
                  <div class="custom-container">
                    <i class="fa fa-download" aria-hidden="true"></i>
                    <label for="kbis_certificate" class="labeltxt readfor m-0">{{'K-BIS Certificate' | translate}}</label>
                  </div>
                </label>
              </a>
            </div>

            <div class="col-md-6 mt-4" *ngIf="companyDetails.nif_certificate">
              <a id="nif_certificate_name" [attr.href]="companyDetails.nif_certificate ? companyDetails.nif_certificate : null" class="viewFile text-center" target="_blank">
                <label for="nif_certificate" class="file-upload-card labeltxt ">
                  <div class="custom-container">
                    <i class="fa fa-download" aria-hidden="true"></i>
                    <label for="nif_certificate" class="labeltxt readfor m-0">{{'NIF Certificate' | translate}}</label>
                  </div>
                </label>
              </a>
            </div>

            <div class="col-md-6 mt-3" *ngIf="companyDetails.statuts">
              <!-- <label for="statuts" class="labeltxt">{{'Statuts' | translate}}</label> -->
              <a id="statuts_name" [attr.href]="companyDetails.statuts ? companyDetails.statuts : null" class="viewFile text-center" target="_blank">
                <label for="statuts" class="file-upload-card labeltxt">
                  <div class="custom-container">
                    <!-- <img src="assets/images/upload_icon.png"> -->
                    <!-- <p class="text-center">{{'Upload image or drop a file' | translate}}</p> -->
                    <i class="fa fa-download" aria-hidden="true"></i>
                    <label for="statuts" class="labeltxt m-0">{{'Statuts' | translate}}</label>
                  </div>
                </label>
              </a>
              <!-- <input class="d-none" id="statuts" type="file" name="statuts" (change)="upload('statuts', 'statuts_name', $event, 'statuts_business')" data-target="statuts_business"> -->
              <!--  <div *ngIf="isSubmitted && g.statuts_business.errors" class="invalid-feedback">
                      <div *ngIf="g.statuts_business.errors?.required">{{'Upload Statuts'|translate}} {{'is required'|translate}}</div>
                    </div> -->
            </div>
            <div class="col-md-6 mt-3" *ngIf="companyDetails.technical_license">
              <!-- <label for="technical_license" class="labeltxt">{{'Technical license' | translate}}</label> -->
              <a id="technical_license_name" [attr.href]="companyDetails.technical_license ? companyDetails.technical_license : null" class="viewFile text-center" target="_blank">
                <label for="technical_license" class="file-upload-card labeltxt">
                  <div class="custom-container">
                    <!-- <img src="assets/images/upload_icon.png"> -->
                    <!-- <p class="text-center">{{'Upload image or drop a file' | translate}}</p> -->
                    <i class="fa fa-download" aria-hidden="true"></i>
                    <label for="technical_license" class="labeltxt">{{'Technical license' | translate}}</label>
                  </div>
                </label>
              </a>
              <!--   <input class="d-none" id="technical_license" type="file" name="technical_license" (change)="upload('technical_license', 'technical_license_name', $event, 'business_technical_license')" data-target="business_technical_license">
                    
                    <div *ngIf="isSubmitted && g.business_technical_license.errors" class="invalid-feedback">
                      <div *ngIf="g.business_technical_license.errors?.required">{{'Upload Technical license'|translate}} {{'is required'|translate}}</div>
                    </div> -->
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt-3">
              <div class="signature-parent">
                <label for="">{{'Signature'|translate}}</label>
                <div class="signature-container">
                  <img *ngIf="companyDetails" src="{{companyDetails.signature}}">
                  <input type="text d-none">
                  <!-- formControlName="signature" -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container mt-5">
          <h6 class="">{{'Bank Details' | translate}}</h6>
        </div>
        <div class="line"></div>
        <div class="container" id="bank_section">
          <div class="row">
            <div class="col-md-12 mt-3" formArrayName="selected_bank_id">
              <div class="bank-card" *ngFor="let bank of bankdata; let i = index">
                <div class="row align-items-center justify-content-center">
                  <!--   <div class="col-md-1">
                    <div class="tableFooter">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" [value]="bank.bank_id" id="flexCheckDefault" (change)="onChange(bank.bank_id, $event.target.checked)" checked>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-md-5">
                    <label for="bank{{ bank.bank_id }}">
                      <img src="{{ bank.bank_logo }}">
                    </label>
                    <div class="card-child" *ngIf="bank.bank_type == 1">
                      <label for="">{{'Account number'|translate}} : </label>
                      <h5> {{bank.ac_number}}</h5>
                    </div>
                    <div class="card-child" *ngIf="bank.bank_type == 2">
                      <label for="">{{'Mobile Number'|translate}} : </label>
                      <h5> {{bank.ac_number}}</h5>
                    </div>
                    <div class="card-child">
                      <label for="">{{'Company Name'|translate}} : </label>
                      <h5> {{bank.account_name}}</h5>
                    </div>
                    <div class="card-child">
                      <label for="">{{'Bank name'|translate}} : </label>
                      <h5>{{bank.bank_name}}</h5>
                    </div>
                    <div class="card-child" *ngIf="bank.bank_type == 1 && bank?.rib_key">
                      <label for="">{{'RIB key '|translate}} : </label>
                      <h5> {{bank.rib_key}}</h5>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <ng-container *ngIf="bank?.bank_number">
                      <div class="card-child">
                        <label for="">{{'Bank number'|translate}} : </label>
                        <h5> {{bank.bank_number}}</h5>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="bank?.bank_counter">
                      <div class="card-child">
                        <label for="">{{'Bank counter'|translate}} : </label>
                        <!-- <input [readonly]="isDisable" [class.disabled-input]="isDisable" type="text" formControlName="i"> -->
                        <h5> {{bank.bank_counter}}</h5>
                      </div>
                    </ng-container>
                    <div *ngIf="bank.bank_type == 1 && bank.bank_slip != null" class="custom-container">
                      <a href="{{bank.bank_slip}}" target="_blank">
                        <label for="bank_ac_statement" class="file-upload-card labeltxt">
                          <div class="custom-container">
                            <!-- <img src="assets/images/upload_icon.png"> -->
                            <i class="fa fa-download" aria-hidden="true"></i>
                            <label for="bank_ac_statement" class="labeltxt">{{'Bank account statement' | translate}}</label>
                          </div>
                        </label>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mt-3">
              <div class="input-container" [owlDateTimeTrigger]="dt42">
                <label>{{'Created Date' | translate}}</label>
                <div class="date-field">
                  <input class="" [max]="todayDate" [owlDateTime]="dt42" name="created_date" formControlName="created_date">
                  <div class="calendar input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dt42></owl-date-time>
                <div *ngIf="isSubmitted && f.created_date.errors" class="invalid-feedback">
                  <div *ngIf="f.created_date.errors?.required">{{'Created Date'|translate}} {{'is required'|translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-3">
              <div class="input-container" [owlDateTimeTrigger]="dt46">
                <label class="labeltxt-sm">{{'Select Service started date' | translate}}</label>
                <div class="date-field">
                  <input class="" [owlDateTime]="dt46" name="service_start_date" formControlName="service_start_date">
                  <div class="calendar input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" #dt46></owl-date-time>
                <div *ngIf="isSubmitted && f.service_start_date.errors" class="invalid-feedback">
                  <div *ngIf="f.service_start_date.errors?.required">{{'Service started date'|translate}} {{'is required'|translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 mt-3">
              <label for="">{{'Guardianship (If Administration/Collectivity)'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.guardianship}}</h5>
            </div>
            <div class="col-md-6 col-12 mt-3">
              <label for="">{{"Branch of activity"|translate}}</label>
              <h5 class="input-txt">{{companyDetails.branch_of_activity}}</h5>
            </div>
          </div>
        </div>
        <div class="container mt-5">
          <h6 class="">{{'Nombre de travailleurs'|translate}}</h6>
        </div>
        <div _ngcontent-mno-c3="" class="line"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-12 mt-2">
              <label for="">{{'Men'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.worker_men}}</h5>
            </div>
            <div class="col-md-6 col-12 mt-2">
              <label for="">{{'Women'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.worker_women}}</h5>
            </div>
          </div>
        </div>
        <div class="container mt-5">
          <h6 class="">{{'Number of interns' | translate}}</h6>
        </div>
        <div _ngcontent-mno-c3="" class="line"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-12 mt-2">
              <label for="">{{'Men'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.interns_men_no}}</h5>
            </div>
            <div class="col-md-6 col-12 mt-2">
              <label for="">{{'Women'|translate}}</label>
              <h5 class="input-txt">{{companyDetails.interns_women_no}}</h5>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="last_sec mt-4">
            <div class="tableFooter approval-checkbox">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [checked]="f.confirm_account.value" id="confirm_account" formControlName="confirm_account">
                <label class="form-check-label" for="confirm_account">
                  {{"By clicking on Submit, you certify that the information declared reflects the reality of the company's social situation." | translate}}
                </label>
              </div>
              <div *ngIf="isSubmitted && f.confirm_account.errors" class="invalid-feedback">
                <div *ngIf="f.confirm_account.errors?.required">{{'Please check the declaration to Continue'|translate}}</div>
              </div>
            </div>
            <div class="buttons report_btn mb-5 text-center">
              <button class="btn btn-medium" type="submit">{{'Submit' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!--   <div class="checkboxSection">
         <mat-checkbox class="example-margin" ></mat-checkbox>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam inventore animi recusandae facilis! Rerum, incidunt et voluptate aut quia voluptates asperiores distinctio tempora aliquid unde?</p>
        </div> -->
</div>
<!-- cnss form ends-->
<!-- ccps success modal-->
<section class="modal-section2">
  <div class="modal fade" id="successModal" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/link_success1.png">
            </div>
            <div class="text-container text-center">
              <h4 class="modal-header-txt">{{'Company details have been successfully updated' | translate}}</h4>
              <!-- <p class="para-light">{{'linked company with CCPS message' | translate}}</p> -->
              <button id="submit_btn" class="btn btn-medium" data-dismiss="modal">{{'OK' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- ccps success modal ends-->
<app-footer></app-footer>
